import { useTranslation } from 'react-i18next';
import { Terminal } from 'lucide-react';
import { useWorkspace } from '@/workspace/WorkspaceContext';
import { Badge } from '@/components/ui/badge';
import { McpTab } from '@/components/organization/McpTab';

export function Mcp(): JSX.Element {
  const { t } = useTranslation();
  const { currentBotId, currentBot } = useWorkspace();

  if (!currentBotId) {
    return (
      <div className="rounded-md border border-dashed p-8 text-center text-sm text-muted-foreground">
        {t('mcpPage.selectBot', {
          defaultValue: 'Select a bot from the workspace switcher to configure its MCP server.',
        })}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="flex items-center gap-3">
        <Terminal className="h-6 w-6 text-primary" />
        <div>
          <h1 className="text-2xl font-semibold">{t('mcpPage.title', { defaultValue: 'MCP' })}</h1>
          <p className="text-xs text-muted-foreground">
            {t('mcpPage.subtitle', {
              defaultValue:
                'Expose {{bot}} as an MCP server for Claude Code, Gemini CLI, or Claude Desktop.',
              bot: currentBot?.name ?? currentBotId,
            })}
          </p>
        </div>
        {currentBot ? (
          <Badge variant="secondary" className="ml-auto font-mono">
            {currentBotId}
          </Badge>
        ) : null}
      </header>
      <McpTab />
    </div>
  );
}
